import styled from 'styled-components';

export const NewExperienceButton = styled.button`
  appearance: none;
  outline: none;
  text-decoration: none;

  cursor: pointer;

  background: #17191a;

  font-size: 1.36rem;
  border: none;
  border-radius: 2.26rem;
  padding: 1.13rem 2.6rem;
  color: white;

  font-family: Eesti, serif;
  font-weight: 500;

  transition: background-color 0.3s ease-out, transform 0.3s ease-out;

  :hover {
    background-color: #000000;
    transform: scale(1.05);
  }

  :active {
    background-color: #0a0a0a;
    transform: scale(0.98);
  }
`;
